import React, { Component } from 'react'; 
import ConfirmadorBaja from './ConfirmadorBaja';
import ConfirmadorBloqueo from './ConfirmadorBloqueo';
import BlanqueoPIN from './BlanqueoPIN';
import DenunciaTarjeta from './DenunciaTarjeta';
import ReimpresionTarjeta from './ReimpresionTarjeta';
import HabilitacionTarjeta from './HabilitacionTarjeta';
import ResultadoOperacion from './ResultadoOperacion';

class ModalContenedor extends Component {
    constructor(props) {
        super(props);
    }
    render() { 
        const {actions, modalTipo, data, cuenta} = this.props;

        let componente;
        let claseModal = 'modalModificacionOut';
        
        switch(modalTipo){
            case "CONFIRMADOR-BAJA":{
                componente = <ConfirmadorBaja data={data} actions={actions} cuenta={cuenta} />
                claseModal = 'modalModificacionOutBaja'
                break;
            }
            case "CONFIRMADOR-BLOQUEO":{
                componente = <ConfirmadorBloqueo tarjetaBloqueo = {data.IntegrantesCuenta.tarjetaBloqueo} data={data} actions={actions}/>
                claseModal = 'modalModificacionOutBaja'
                break;
            }
            case "BLANQUEO-TARJETA":{
                componente = <BlanqueoPIN tarjetaBlanqueo = {data.IntegrantesCuenta.tarjetaBlanqueo} data={data} actions={actions}/>
                claseModal = 'modalModificacionOutBaja'
                break;
            }
            case "DENUNCIA-TARJETA":{
                componente = <DenunciaTarjeta tarjetaDenuncia = {data.IntegrantesCuenta.tarjetaDenuncia} data={data} actions={actions}/>
                claseModal = 'modalModificacionOutBaja'
                break;
            }
            case "REIMPRESION-TARJETA":{
                componente = <ReimpresionTarjeta tarjetaReimpresion = {data.IntegrantesCuenta.tarjetaReimpresion} data={data} actions={actions}/>
                claseModal = 'modalModificacionOutBaja'
                break;
            }
            case "HABILITACION-TARJETA":{
                componente = <HabilitacionTarjeta tarjetaHabilitacion = {data.IntegrantesCuenta.tarjetaHabilitacion} data={data} actions={actions}/>
                claseModal = 'modalModificacionOutBaja'
                break;
            }
            case "BLOQUEO-RESULTADO":
            case "PIN-RESULTADO":{
                componente = <ResultadoOperacion resultado = {data.IntegrantesCuenta.resultadoOperacion} actions={actions}/>
                claseModal = 'modalModificacionOutBaja'
                break;
            }
        }
        
        return (
            <div className='modalContainer'>
                <div className={claseModal}>
                {componente}
                </div>
            </div>
        )
    }
}
export default ModalContenedor;